import { S110gS110m01Component } from './s110g-s110m01.component';
import { S110gS110m02Component } from './s110g-s110m02.component';

export { S110gModule } from './s110g.module';

export const S110gSubComponentsMap = {
	
};

export const S110gComponentsMap = {
	"s110g-s110m01": S110gS110m01Component,
	"s110g-s110m02": S110gS110m02Component
};

export const S110gComponents = [
	S110gS110m01Component,
	S110gS110m02Component
];

